"use client";

import dynamic from "next/dynamic";

const Analytics = dynamic(
  () => import("@vercel/analytics/react").then((m) => m.Analytics),
  { ssr: false },
);

/** Loads after hydration so analytics is not in the critical script path. */
export function DeferredAnalytics() {
  return <Analytics />;
}
